import React, { useContext } from "react";
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import XMLViewer from 'react-xml-viewer';
import { useLocation } from "react-router-dom";
import {useGetReportById} from '@app/sdk';
import { AccountContext } from "../../AccountContext";

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function Report() {
    const { accountId } = useContext(AccountContext);
    const params = useParams();
    const reportId = params.id;
    let query = useQuery();
    let reportType = query.get("reportType");

    const { data: report, isLoading } = useGetReportById({ reportId });

    return (
        <>
            <h2>Report</h2>
            {isLoading && <div className="ui active centered inline loader" />}

            {!isLoading && (!report) && <div>Report not found</div>}

            {!isLoading && report &&
                <div>
                    <div>
                        <XMLViewer xml={report} />
                    </div>
                    <div style={{ textAlign:"right" }}>
                        <Link to={`/accounts/${accountId}/bacs?reportType=${reportType}`}>
                            <button className={`ui primary button`}>BACK</button>
                        </Link>
                    </div>
                </div>}
        </>)
}